import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../redux/cartSlice';
import { translations } from '../utils/translations';
import AboutHero from './AboutHero';
import './AboutUs.css';

const textContent = {
  nl: {
    title: "Smart Telecom Store – Betrouwbare Smartphones voor de Beste Prijs",
    welcome: "Welkom bij Smart Telecom Store – jouw betrouwbare webshop voor hoogwaardige smartphones en accessoires in Nederland.",
    topQuality: { title: "Topkwaliteit Smartphones", desc: "Wij bieden een zorgvuldig geselecteerd assortiment van nieuw en refurbished toestellen:", items: ["Apple iPhones", "Samsung Galaxy toestellen", "Andere populaire merken"], footer: "Alle toestellen worden grondig gecontroleerd en getest voor 100% functionaliteit." },
    whyUs: { title: "Waarom kiezen voor ons?", desc: "Wij zorgen ervoor dat je de beste deal krijgt met maximale zekerheid en service.", items: ["Snelle levering – 1–2 werkdagen in heel Nederland", "Garantie inbegrepen – Minimaal 6 tot 12 maanden", "Scherpe prijzen – Betaal minder, krijg meer", "Veilige betalingen – iDEAL, Klarna en meer", "Klantenservice – Snelle ondersteuning via WhatsApp & e-mail"] },
    reliable: { title: "100% Betrouwbaar & Transparant", desc: "Bij ons weet je precies waar je aan toe bent, zonder kleine lettertjes.", items: ["Geregistreerd bedrijf in Nederland (KvK: 42091099)", "Duidelijke retour- en garantievoorwaarden", "Eerlijke productbeschrijvingen (conditie: Nieuw / Grade A / Grade B)"] },
    reviews: { quotes: ["“Snelle levering”", "“Goede prijs en uitstekende service”"] },
    offers: { title: "Speciale Aanbiedingen", desc: "Bekijk onze nieuwste deals en bespaar op topmodellen zoals iPhone, Samsung, Xiaomi en andere Android-telefoons.", action: "Shop nu en profiteer" },
    contact: { title: "Hulp nodig?", desc: "Neem gerust contact met ons op via de onderstaande kanalen:", whatsapp: "+31-687748358", email: "smarttelecom.nl@gmail.com", website: "www.smarttelecomstore.com", footer: "Wij helpen je graag verder!", tagline: "Smart Telecom Store – Slim kopen, beter besparen." }
  },
  en: {
    title: "Smart Telecom Store – Reliable Smartphones at the Best Price",
    welcome: "Welcome to Smart Telecom Store – your reliable webshop for high-quality smartphones and accessories in the Netherlands.",
    topQuality: { title: "Top Quality Smartphones", desc: "We offer a carefully selected range of new and refurbished devices:", items: ["Apple iPhones", "Samsung Galaxy devices", "Other popular brands"], footer: "All devices are thoroughly inspected and tested for 100% functionality." },
    whyUs: { title: "Why choose us?", desc: "We make sure you get the best deal with maximum security and service.", items: ["Fast delivery – 1–2 working days throughout the Netherlands", "Warranty included – Minimum 6 to 12 months", "Competitive prices – Pay less, get more", "Secure payments – iDEAL, Klarna and more", "Customer service – Fast support via WhatsApp & email"] },
    reliable: { title: "100% Reliable & Transparent", desc: "With us you know exactly what to expect, no hidden clauses.", items: ["Registered company in the Netherlands (CoC: 42091099)", "Clear return and warranty conditions", "Honest product descriptions (condition: New / Grade A / Grade B)"] },
    reviews: { quotes: ["“Fast delivery”", "“Good price and excellent service”"] },
    offers: { title: "Special Offers", desc: "Check out our latest deals and save on top models such as iPhone, Samsung, Xiaomi, and other Android phones.", action: "Shop now and benefit" },
    contact: { title: "Need help?", desc: "Feel free to contact us through any of the channels below:", whatsapp: "+31-687748358", email: "smarttelecom.nl@gmail.com", website: "www.smarttelecomstore.com", footer: "We are happy to help you!", tagline: "Smart Telecom Store – Buy smart, save better." }
  },
  es: {
    title: "Smart Telecom Store – Teléfonos Inteligentes Confiables al Mejor Precio",
    welcome: "Bienvenido a Smart Telecom Store – su tienda en línea confiable de teléfonos y accesorios de alta calidad en los Países Bajos.",
    topQuality: { title: "Teléfonos de Alta Calidad", desc: "Ofrecemos una gama cuidadosamente seleccionada de dispositivos nuevos y reacondicionados:", items: ["Apple iPhones", "Dispositivos Samsung Galaxy", "Otras marcas populares"], footer: "Todos los dispositivos son inspeccionados y probados a fondo para asegurar una funcionalidad del 100%." },
    whyUs: { title: "¿Por qué elegirnos?", desc: "Nos aseguramos de que obtenga la mejor oferta con la máxima seguridad y servicio.", items: ["Entrega rápida: 1-2 días hábiles en toda Holanda", "Garantía incluida: Mínimo de 6 a 12 meses", "Precios competitivos: Pague menos, obtenga más", "Pagos seguros: iDEAL, Klarna y más", "Servicio al cliente: Soporte rápido por WhatsApp y correo"] },
    reliable: { title: "100% Confiable y Transparente", desc: "Con nosotros sabe exactamente qué esperar, sin cláusulas ocultas.", items: ["Empresa registrada en los Países Bajos (CoC: 42091099)", "Condiciones claras de devolución y garantía", "Descripciones de productos honestas (condición: Nuevo / Grado A / Grado B)"] },
    reviews: { quotes: ["“Entrega rápida”", "“Buen precio y excelente servicio”"] },
    offers: { title: "Ofertas Especiales", desc: "Consulte nuestras últimas ofertas y ahorre en modelos superiores como iPhone, Samsung, Xiaomi y otros teléfonos Android.", action: "Compre ahora y aproveche" },
    contact: { title: "¿Necesita ayuda?", desc: "No dude en contactarnos a través de cualquiera de los siguientes canales:", whatsapp: "+31-687748358", email: "smarttelecom.nl@gmail.com", website: "www.smarttelecomstore.com", footer: "¡Estamos encantados de ayudarle!", tagline: "Smart Telecom Store – Compre inteligentemente, ahorre mejor." }
  },
  fr: {
    title: "Smart Telecom Store – Smartphones Fiables au Meilleur Prix",
    welcome: "Bienvenue sur Smart Telecom Store – votre boutique en ligne fiable pour des smartphones et accessoires de haute qualité aux Pays-Bas.",
    topQuality: { title: "Smartphones de Haute Qualité", desc: "Nous proposons une gamme soigneusement sélectionnée d'appareils neufs et reconditionnés :", items: ["Apple iPhones", "Appareils Samsung Galaxy", "Autres marques populaires"], footer: "Tous les appareils sont minutieusement inspectés et testés pour garantir une fonctionnalité à 100%." },
    whyUs: { title: "Pourquoi nous choisir ?", desc: "Nous veillons à ce que vous obteniez la meilleure offre avec une sécurité et un service maximum.", items: ["Livraison rapide : 1 à 2 jours ouvrés dans tous les Pays-Bas", "Garantie incluse : Minimum 6 à 12 mois", "Prix compétitifs : Payez moins, obtenez plus", "Paiements sécurisés : iDEAL, Klarna et plus", "Service client : Assistance rapide via WhatsApp et e-mail"] },
    reliable: { title: "100% Fiable et Transparent", desc: "Avec nous, vous savez exactement à quoi vous attendre, sans clauses cachées.", items: ["Entreprise enregistrée aux Pays-Bas (CoC : 42091099)", "Conditions claires de retour et de garantie", "Descriptions honnêtes (état : Neuf / Grade A / Grade B)"] },
    reviews: { quotes: ["“Livraison rapide”", "“Bon prix et excellent service”"] },
    offers: { title: "Offres Spéciales", desc: "Découvrez nos dernières offres et économisez sur des modèles phares comme l'iPhone, Samsung, Xiaomi et autres téléphones Android.", action: "Achetez maintenant et profitez" },
    contact: { title: "Besoin d'aide ?", desc: "N'hésitez pas à nous contacter via les canaux ci-dessous :", whatsapp: "+31-687748358", email: "smarttelecom.nl@gmail.com", website: "www.smarttelecomstore.com", footer: "Nous sommes heureux de vous aider !", tagline: "Smart Telecom Store – Achetez malin, économisez mieux." }
  },
  de: {
    title: "Smart Telecom Store – Zuverlässige Smartphones zum besten Preis",
    welcome: "Willkommen im Smart Telecom Store – Ihrem zuverlässigen Webshop für hochwertige Smartphones und Zubehör in den Niederlanden.",
    topQuality: { title: "Top-Qualität Smartphones", desc: "Wir bieten ein sorgfältig ausgewähltes Sortiment an neuen und überholten Geräten:", items: ["Apple iPhones", "Samsung Galaxy Geräte", "Andere beliebte Marken"], footer: "Alle Geräte werden gründlich inspiziert und auf 100% Funktionalität getestet." },
    whyUs: { title: "Warum uns wählen?", desc: "Wir sorgen dafür, dass Sie das beste Angebot bei maximaler Sicherheit und bestem Service erhalten.", items: ["Schnelle Lieferung – 1-2 Werktage in ganz Holland", "Inklusive Garantie – Mindestens 6 bis 12 Monate", "Wettbewerbsfähige Preise – Weniger zahlen, mehr bekommen", "Sichere Zahlungen – iDEAL, Klarna und mehr", "Kundenservice – Schneller Support über WhatsApp & E-Mail"] },
    reliable: { title: "100% Zuverlässig & Transparent", desc: "Bei uns wissen Sie genau, was Sie erwartet, ohne versteckte Klauseln.", items: ["Eingetragenes Unternehmen in den Niederlanden (CoC: 42091099)", "Klare Rückgabe- und Garantiebedingungen", "Ehrliche Produktbeschreibungen (Zustand: Neu / Grad A / Grad B)"] },
    reviews: { quotes: ["“Schnelle Lieferung”", "“Guter Preis und exzellenter Service”"] },
    offers: { title: "Sonderangebote", desc: "Schauen Sie sich unsere neuesten Angebote an und sparen Sie bei Top-Modellen wie iPhone, Samsung, Xiaomi und anderen Android-Telefonen.", action: "Jetzt kaufen und profitieren" },
    contact: { title: "Brauchen Sie Hilfe?", desc: "Kontaktieren Sie uns gerne über einen der folgenden Kanäle:", whatsapp: "+31-687748358", email: "smarttelecom.nl@gmail.com", website: "www.smarttelecomstore.com", footer: "Wir helfen Ihnen gerne weiter!", tagline: "Smart Telecom Store – Clever einkaufen, besser sparen." }
  },
  it: {
    title: "Smart Telecom Store – Smartphone Affidabili al Miglior Prezzo",
    welcome: "Benvenuti a Smart Telecom Store – il vostro negozio online affidabile per smartphone e accessori di alta qualità nei Paesi Bassi.",
    topQuality: { title: "Smartphone di Alta Qualità", desc: "Offriamo una gamma accuratamente selezionata di dispositivi nuovi e ricondizionati:", items: ["Apple iPhones", "Dispositivi Samsung Galaxy", "Altri marchi popolari"], footer: "Tutti i dispositivi sono accuratamente ispezionati e testati per garantire una funzionalità del 100%." },
    whyUs: { title: "Perché sceglierci?", desc: "Ci assicuriamo che otteniate la migliore offerta con la massima sicurezza e servizio.", items: ["Consegna rapida: 1-2 giorni lavorativi in tutta l'Olanda", "Garanzia inclusa: Minimo da 6 a 12 mesi", "Prezzi competitivi: Paga meno, ottieni di più", "Pagamenti sicuri: iDEAL, Klarna e altro", "Servizio clienti: Supporto rapido tramite WhatsApp ed e-mail"] },
    reliable: { title: "100% Affidabile e Trasparente", desc: "Con noi sai esattamente cosa aspettarti, senza clausole nascoste.", items: ["Società registrata nei Paesi Bassi (CoC: 42091099)", "Condizioni chiare di reso e garanzia", "Descrizioni oneste (condizione: Nuovo / Grado A / Grado B)"] },
    reviews: { quotes: ["“Consegna rapida”", "“Buon prezzo e servizio eccellente”"] },
    offers: { title: "Offerte Speciali", desc: "Scopri le nostre ultime offerte e risparmia sui modelli di punta come iPhone, Samsung, Xiaomi e altri telefoni Android.", action: "Acquista ora e approfitta" },
    contact: { title: "Serve aiuto?", desc: "Sentitevi liberi di contattarci attraverso uno dei canali sottostanti:", whatsapp: "+31-687748358", email: "smarttelecom.nl@gmail.com", website: "www.smarttelecomstore.com", footer: "Siamo felici di aiutarvi!", tagline: "Smart Telecom Store – Compra in modo intelligente, risparmia di più." }
  },
  pt: {
    title: "Smart Telecom Store – Smartphones Confiáveis ao Melhor Preço",
    welcome: "Bem-vindo à Smart Telecom Store – sua loja online confiável de smartphones e acessórios de alta qualidade na Holanda.",
    topQuality: { title: "Smartphones de Alta Qualidade", desc: "Oferecemos uma gama cuidadosamente selecionada de dispositivos novos e recondicionados:", items: ["Apple iPhones", "Dispositivos Samsung Galaxy", "Outras marcas populares"], footer: "Todos os dispositivos são inspecionados e testados exaustivamente para 100% de funcionalidade." },
    whyUs: { title: "Por que nos escolher?", desc: "Garantimos a melhor oferta com o máximo de segurança e serviço.", items: ["Entrega rápida – 1-2 dias úteis em toda a Holanda", "Garantia incluída – Mínimo de 6 a 12 meses", "Preços competitivos – Pague menos, ganhe mais", "Pagamentos seguros – iDEAL, Klarna e mais", "Atendimento ao cliente – Suporte rápido via WhatsApp e e-mail"] },
    reliable: { title: "100% Confiável e Transparente", desc: "Conosco, você sabe exatamente o que esperar, sem cláusulas ocultas.", items: ["Empresa registrada na Holanda (CoC: 42091099)", "Condições claras de devolução e garantia", "Descrições honestas de produtos (condição: Novo / Grau A / Grau B)"] },
    reviews: { quotes: ["“Entrega rápida”", "“Bom preço e excelente serviço”"] },
    offers: { title: "Ofertas Especiais", desc: "Confira nossas ofertas mais recentes e economize nos principais modelos como iPhone, Samsung, Xiaomi e outros telefones Android.", action: "Compre agora e aproveite" },
    contact: { title: "Precisa de ajuda?", desc: "Sinta-se à vontade para nos contatar através dos canais abaixo:", whatsapp: "+31-687748358", email: "smarttelecom.nl@gmail.com", website: "www.smarttelecomstore.com", footer: "Estamos felizes em ajudar!", tagline: "Smart Telecom Store – Compre inteligente, economize melhor." }
  },
  el: {
    title: "Smart Telecom Store – Αξιόπιστα Smartphones στην Καλύτερη Τιμή",
    welcome: "Καλώς ήρθατε στο Smart Telecom Store – το αξιόπιστο ηλεκτρονικό σας κατάστημα για smartphone και αξεσουάρ υψηλής ποιότητας στην Ολλανδία.",
    topQuality: { title: "Smartphones Κορυφαίας Ποιότητας", desc: "Προσφέρουμε μια προσεκτικά επιλεγμένη σειρά νέων και ανακατασκευασμένων συσκευών:", items: ["Apple iPhones", "Συσκευές Samsung Galaxy", "Άλλες δημοφιλείς μάρκες"], footer: "Όλες οι συσκευές ελέγχονται εξονυχιστικά για 100% λειτουργικότητα." },
    whyUs: { title: "Γιατί να μας επιλέξετε;", desc: "Φροντίζουμε να έχετε την καλύτερη προσφορά με μέγιστη ασφάλεια και εξυπηρέτηση.", items: ["Γρήγορη παράδοση – 1–2 εργάσιμες ημέρες σε όλη την Ολλανδία", "Περιλαμβάνεται εγγύηση – Ελάχιστο 6 έως 12 μήνες", "Ανταγωνιστικές τιμές – Πληρώστε λιγότερα, κερδίστε περισσότερα", "Ασφαλείς πληρωμές – iDEAL, Klarna και άλλα", "Εξυπηρέτηση πελατών – Γρήγορη υποστήριξη μέσω WhatsApp & email"] },
    reliable: { title: "100% Αξιόπιστο & Διαφανές", desc: "Μαζί μας ξέρετε ακριβώς τι να περιμένετε, χωρίς κρυφούς όρους.", items: ["Εγγεγραμμένη εταιρεία στην Ολλανδία (CoC: 42091099)", "Ξεκάθαροι όροι επιστροφής και εγγύησης", "Ειλικρινείς περιγραφές προϊόντων (κατάσταση: Νέο / Βαθμός Α / Βαθμός Β)"] },
    reviews: { quotes: ["“Γρήγορη παράδοση”", "“Καλή τιμή και άριστη εξυπηρέτηση”"] },
    offers: { title: "Ειδικές Προσφορές", desc: "Δείτε τις τελευταίες μας προσφορές και εξοικονομήστε χρήματα σε κορυφαία μοντέλα όπως iPhone, Samsung, Xiaomi και άλλα τηλέφωνα Android.", action: "Αγοράστε τώρα και επωφεληθείτε" },
    contact: { title: "Χρειάζεστε βοήθεια;", desc: "Μη διστάσετε να επικοινωνήσετε μαζί μας μέσω των παρακάτω καναλιών:", whatsapp: "+31-687748358", email: "smarttelecom.nl@gmail.com", website: "www.smarttelecomstore.com", footer: "Είμαστε στην ευχάριστη θέση να σας βοηθήσουμε!", tagline: "Smart Telecom Store – Αγοράστε έξυπνα, εξοικονομήστε καλύτερα." }
  }
};

const AboutUs = () => {
  const selectedLang = useSelector(selectLanguage) || { code: 'en' };
  const t = translations[selectedLang.code || 'en'] || translations.en;
  const content = textContent[selectedLang.code] || textContent['en'];

  const [openFaqIndex, setOpenFaqIndex] = useState(0);

  const toggleFaq = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? -1 : index);
  };

  const faqData = [
    {
      question: t.faqQ1 || "What services does Smart Telecom Store offer?",
      answer: t.faqA1 || "Smart Telecom Store offers a wide range of premium services, including smartphone and tablet sales (brand-new and certified pre-owned), high-quality repair services (screen replacement, battery diagnostics, motherboard soldering), and a curated collection of tech accessories like cases, cables, chargers, and audio gear."
    },
    {
      question: t.faqQ2 || "How long does a typical mobile repair take?",
      answer: t.faqA2 || "Most standard repairs like screen replacements, battery changes, and charging port fixes are completed within 30 to 60 minutes. You can walk in or book an appointment online. Advanced diagnostics or motherboard repairs may take 1 to 2 business days."
    },
    {
      question: t.faqQ3 || "Do you offer a warranty on repairs and purchases?",
      answer: t.faqA3 || "Absolutely! We offer a 6-month worry-free warranty on all repair services and replacement parts. Brand-new retail products carry their official manufacturer warranties."
    },
    {
      question: t.faqQ4 || "Can I trade in my old device at Smart Telecom Store?",
      answer: t.faqA4 || "Yes, you can! Bring your old phone or tablet to any of our stores. We will run a quick evaluation and offer you competitive store credit or cash that you can apply immediately to upgrade your device."
    }
  ];

  useEffect(() => {
    document.title = `${content.title}`;
    
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    const originalContent = metaDescription.content;
    metaDescription.content = content.welcome;

    return () => {
      document.title = 'Smart Telecom Store | Premium Electronics Store';
      if (metaDescription) {
        metaDescription.content = originalContent || '';
      }
    };
  }, [content]);

  return (
    <div className="about-us-page">
      <AboutHero />

      {/* Intro Section */}
      <section className="about-intro-section">
        <h1 className="about-intro-title">{content.title}</h1>
        <p className="about-intro-desc">{content.welcome}</p>
      </section>

      {/* Features Grid */}
      <section className="about-features-container">
        
        {/* Top Quality Card */}
        <div className="premium-card">
          <div className="card-icon-wrapper">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
              <line x1="12" y1="18" x2="12.01" y2="18"></line>
            </svg>
          </div>
          <h3 className="card-title">{content.topQuality.title}</h3>
          <p className="card-desc">{content.topQuality.desc}</p>
          <ul className="premium-list">
            {content.topQuality.items.map((item, idx) => (
              <li key={idx}>
                <svg className="list-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                {item}
              </li>
            ))}
          </ul>
          <div className="card-footer-note">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
            {content.topQuality.footer}
          </div>
        </div>

        {/* Why Choose Us Card */}
        <div className="premium-card">
          <div className="card-icon-wrapper">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
            </svg>
          </div>
          <h3 className="card-title">{content.whyUs.title}</h3>
          <p className="card-desc">{content.whyUs.desc}</p>
          <ul className="premium-list">
            {content.whyUs.items.map((item, idx) => (
              <li key={idx}>
                <svg className="list-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Reliable & Transparent Card */}
        <div className="premium-card">
          <div className="card-icon-wrapper">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
          </div>
          <h3 className="card-title">{content.reliable.title}</h3>
          <p className="card-desc">{content.reliable.desc}</p>
          <ul className="premium-list">
            {content.reliable.items.map((item, idx) => (
              <li key={idx}>
                <svg className="list-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                {item}
              </li>
            ))}
          </ul>
        </div>

      </section>

      {/* Reviews Banner Section */}
      <section className="about-reviews-section">
        <div className="reviews-banner">
          <div className="stars-container">
            {[1, 2, 3, 4, 5].map(star => (
              <svg key={star} className="star-icon" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
              </svg>
            ))}
          </div>
          <div className="quotes-container">
            {content.reviews.quotes.map((quote, idx) => (
              <div key={idx}>{quote}</div>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom Split Section: Offers & Contact */}
      <section className="about-bottom-grid">
        
        {/* Special Offers (Dark Mode Box) */}
        <div className="offers-card">
          <h2 className="offers-title">{content.offers.title}</h2>
          <p className="offers-desc">{content.offers.desc}</p>
          <a href="/" className="offers-btn">
            {content.offers.action}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </a>
        </div>

        {/* Contact Info (Clean Light Box) */}
        <div className="contact-card">
          <h2 className="contact-title">{content.contact.title}</h2>
          <p className="contact-desc">{content.contact.desc}</p>
          
          <div className="contact-links">
            <div className="contact-link-item">
              <div className="contact-icon-wrapper">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              </div>
              <a href={`https://wa.me/${content.contact.whatsapp.replace(/[^0-9]/g, '')}`}>{content.contact.whatsapp}</a>
            </div>
            
            <div className="contact-link-item">
              <div className="contact-icon-wrapper">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <a href={`mailto:${content.contact.email}`}>{content.contact.email}</a>
            </div>

            <div className="contact-link-item">
              <div className="contact-icon-wrapper">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="2" y1="12" x2="22" y2="12"></line>
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                </svg>
              </div>
              <a href={`https://${content.contact.website}`}>{content.contact.website}</a>
            </div>
          </div>

          <div className="contact-footer-block">
            <div className="contact-footer-text">{content.contact.footer}</div>
            <div className="contact-tagline">{content.contact.tagline}</div>
          </div>
        </div>

      </section>

      {/* Frequently Asked Questions Section */}
      <section className="faq-section">
        <div className="faq-inner">
          <div className="faq-left-col">
            <div className="faq-pill-badge">
              <svg className="faq-pill-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
              <span>{t.faqPillBadge || "Frequently asked questions"}</span>
            </div>
            <h2 className="faq-title">
              {t.faqTitleFirst || "Frequently asked"} <br />
              <span className="faq-title-highlight">{t.faqTitleSecond || "questions"}</span>
            </h2>
            <p className="faq-description">
              {t.faqSectionDesc || "Got questions about our services, repair process, or product warranties? We have gathered answers to some of the most common questions our clients ask."}
            </p>
          </div>

          <div className="faq-right-col">
            <div className="faq-accordion-list">
              {faqData.map((item, index) => {
                const isOpen = openFaqIndex === index;
                return (
                  <div key={index} className={`faq-accordion-item ${isOpen ? 'active' : ''}`}>
                    <button className="faq-question-btn" onClick={() => toggleFaq(index)} aria-expanded={isOpen}>
                      <span className="faq-question-text">{item.question}</span>
                      <div className="faq-arrow-icon-wrapper">
                        <svg className={`faq-arrow-svg ${isOpen ? 'rotated' : ''}`} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </div>
                    </button>
                    <div className={`faq-answer-collapse ${isOpen ? 'expanded' : ''}`}>
                      <div className="faq-answer-content">
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default AboutUs;
